import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { Dispatch } from 'redux'
import { TradeSubTradeItem } from 'app/models/trade-sub-trade-params'
import { coalesceThunkByKey } from 'app/state/utils/coalesce-thunk'
import {
  failTradeSubTrades,
  getTradeSubTrades,
  startLoadingTradeSubTrades,
  stopLoadingTradeSubTrades,
} from './actions'

/**
 * One trade's sub trades for its expanded row: GET /api/trade-list/:id/sub-trades
 * returns them with buyer, seller and traded facilities already resolved, so the
 * panel no longer loads every sub trade, entity, facility and traded facility in
 * the tenant. Coalesced per trade: two expands in flight share one request.
 */
export const loadTradeSubTrades = coalesceThunkByKey(
  (masterTradeId: string) => async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    try {
      dispatch(startLoadingTradeSubTrades(masterTradeId))
      const response = await client.get(
        `${apiServerUrl}/api/trade-list/${encodeURIComponent(masterTradeId)}/sub-trades`,
      )
      return dispatch(getTradeSubTrades({ masterTradeId, items: response.data as TradeSubTradeItem[] }))
    } catch {
      // The store keeps what it had and the API client logs the request. The
      // trade is marked failed so its panel stops the spinner and offers a
      // retry, instead of waiting forever for rows that are not coming.
      dispatch(failTradeSubTrades(masterTradeId))
    } finally {
      dispatch(stopLoadingTradeSubTrades(masterTradeId))
    }
  },
)
